import { type FC, useCallback } from 'react';
import { TableExtension } from '@remirror/extension-tables';
import { useActive, useCommands } from '@remirror/react-core';
import { CommandButton, type CommandButtonProps } from '@remirror/react-ui';

export type CreateTableButtonProps = Omit<
  CommandButtonProps,
  'commandName' | 'active' | 'enabled' | 'attrs' | 'onSelect'
>;

export const CreateTableButton: FC<CreateTableButtonProps> = (props) => {
  const { createTable } = useCommands<TableExtension>();

  const handleSelect = useCallback(() => {
    if (createTable.enabled()) {
      createTable();
    }
  }, [createTable]);

  const active = useActive<TableExtension>().table();
  const enabled = createTable.enabled() && !active;

  return (
    <CommandButton
      {...props}
      disabled={!enabled}
      commandName="createTable"
      enabled={enabled}
      onSelect={handleSelect}
    />
  );
};
